export default __webpack_public_path__ + "static/media/bet-and-earn.bf9e1cde.gif";